import React from "react";
import { Routes, Route } from "react-router-dom";
import ListCurrency from "../Components/Currency/listCurrency";

const CurrencyRoutes = () => {
  return (
    <Routes>
      <Route path="/currency" element={<ListCurrency/>}></Route>
    </Routes>
  );
};

export default CurrencyRoutes;
